<div *ngIf="!isDealOver" fxLayoutGap="2px" [ngClass]="categoryId4 === 0 ? 'border' : 'noclass'">
  <div *ngIf="categoryId5==0" style="padding-bottom: 5px">
    <calsoft-common-header-carousel [products]="products" [other]="other" [type]="type" [item]="item" [header]="header"
      [id]="id"></calsoft-common-header-carousel>

  </div>
  <div *ngIf="categoryId5==1" style="padding-bottom: 5px">

  </div>

  <div *ngIf="categoryId5==2||categoryId5==3" style="padding-bottom: 5px">
    <div [style.background-color]="item.customField25" class="commonHeader" fxLayout="row"
      fxLayoutAlign="space-between center">
      <span style="font-weight: 500;" [ngStyle.gt-md]="{'font-size': item.customField39}"
        [ngStyle.lt-md]="{'font-size': item.customField40}" [innerHTML]="header | uppercase"></span>

    </div>
  </div>

  <div *ngIf="categoryId5==4" style="padding-bottom: 5px">
    <div [style.background-color]="item.customField25" fxLayout="row" fxLayoutAlign="space-between center"
      fxLayoutAlign.xs="start start">

      <div fxLayout="row" fxLayout.xs="row" fxLayoutAlign="start center" fxLayoutAlign.xs="space-between center"
        fxFlex.xs="100" fxLayoutGap="20px">
        <div *ngIf="!hideTitle" style="font-weight: 500;" [ngStyle.gt-md]="{'font-size': item.customField39 }"
          [ngStyle.lt-md]="{
          'font-size': item.customField40}" [innerHTML]="header ">
        </div>

        <div *ngIf="showTimer">
          <div *ngIf="item.customField31 && !isDealOver" fxLayout="row" fxLayoutAlign="start center" style="gap: 8px;">
            <span>{{item.customField25}}</span>
            <mat-chip color="primary" selected class="countdown">
              {{ days }}d&nbsp;&nbsp;:&nbsp;&nbsp;{{ hours }}h&nbsp;&nbsp;:&nbsp;&nbsp;{{ minutes
              }}m&nbsp;&nbsp;:&nbsp;&nbsp;{{ seconds }}s
            </mat-chip>

          </div>
        </div>

      </div>


      <div style="cursor: pointer;" *ngIf="item.customField26" fxFlex fxLayout="row" fxLayoutAlign="end end"
        fxLayoutGap="7px" fxHide.lt-md>
        <h3 (click)="goToCategory()">{{item.customField26}}</h3>
        <mat-icon style="font-size: 22px;">arrow_forward</mat-icon>
      </div>

    </div>
  </div>



  <div class="carousel" tabindex="0" (keydown)="handleKey($event)">
  <button *ngIf="!isMobile || showArrowsOnMobile" class="nav prev" (click)="moveLeft()" (pointerdown)="pauseForInteraction()" 
  (pointerup)="resumeAfterInteraction()" aria-label="Previous" [disabled]="isPrevDisabled" 
  [attr.aria-disabled]="isPrevDisabled">
    <!-- left arrow SVG -->
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M15 18l-6-6 6-6" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="viewport" #viewportRef
    (pointerdown)="onPointerDown($event); pauseForInteraction()"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event); resumeAfterInteraction()"
    (pointercancel)="onPointerUp($event); resumeAfterInteraction()"
    (mouseenter)="pauseOnHover && pauseForInteraction()"
    (mouseleave)="pauseOnHover && resumeAfterInteraction()"
    >

  <div class="track" fxLayout="row" fxLayoutAlign="start stretch" [fxLayoutGap]="(gapLayout || 0) + 'px'" [style.padding-right.px]="(gapLayout || 0)" [style.transform]="trackTransform">
   <div class="item" *ngFor="let product of categoryProducts; let i = index"
     [style.flex]="itemFlex"
     style="box-sizing: border-box;">
         <calsoft-common-product-details-carousel [urlNavigation]="urlNavigation" [data]="data" [width]="width"
          [heightMobile]="heightMobile" [widthMobile]="widthMobile" [imageType]="imageType" [height]="height"
          [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon" [data]="data"
          [productLayoutEnable]="productLayoutEnable" [showCartIncremented]="showCartIncremented" [type]="'carousel'"
          [product]="product" [preload]="i < preloadCount"></calsoft-common-product-details-carousel>
      </div>
    </div>
  </div>

  <button *ngIf="!isMobile || showArrowsOnMobile" class="nav next" (click)="moveRight()"
   (pointerdown)="pauseForInteraction()"
    (pointerup)="resumeAfterInteraction()"
     aria-label="Next" [disabled]="isNextDisabled" 
     [attr.aria-disabled]="isNextDisabled">
    <!-- right arrow SVG -->
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M9 6l6 6-6 6" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <!-- pagination dots -->
  <div class="dots" *ngIf="showDots">
    <button class="dot" *ngFor="let pageIndex of pages"
            [class.active]="pageIndex === currentPageIndex" (click)="goToPage(pageIndex)" aria-label="Go to page {{pageIndex+1}}"></button>
  </div>

</div>





  <div *ngIf="categoryId5==3" fxLayout="row" fxLayoutAlign="center center"
    style="padding-top: 10px; padding-bottom: 10px;">
    <button class=" btn" (click)="goToCategory()">{{item.customField26}}</button>
  </div>
</div>
<div *ngIf="isDealOver" fxLayoutGap="2px" [ngClass]="categoryId4 === 0 ? 'border' : 'noclass'">
  <div *ngIf="categoryId5==0" style="padding-bottom: 5px">
    <calsoft-common-header-carousel [products]="products" [other]="other" [type]="type" [item]="item" [header]="header"
      [id]="id"></calsoft-common-header-carousel>

  </div>
  <div *ngIf="categoryId5==1" style="padding-bottom: 5px">

  </div>

  <div *ngIf="categoryId5==2||categoryId5==3" style="padding-bottom: 5px">
    <div [style.background-color]="item.customField25" class="commonHeader" fxLayout="row"
      fxLayoutAlign="space-between center">
      <span style="font-weight: 500;" [ngStyle.gt-md]="{'font-size': item.customField39}"
        [ngStyle.lt-md]="{'font-size': item.customField40}" [innerHTML]="header | uppercase"></span>

    </div>
  </div>

  <div *ngIf="categoryId5==4" style="padding-bottom: 5px">
    <div [style.background-color]="item.customField25" fxLayout="row" fxLayoutAlign="space-between center"
      fxLayoutAlign.xs="start start">

      <div fxLayout="row" fxLayout.xs="row" fxLayoutAlign="start center" fxLayoutAlign.xs="space-between center"
        fxFlex.xs="100" fxLayoutGap="20px">
        <div *ngIf="!hideTitle" style="font-weight: 500;" [ngStyle.gt-md]="{'font-size': item.customField39 }"
          [ngStyle.lt-md]="{
          'font-size': item.customField40}" [innerHTML]="header ">
        </div>

        <div *ngIf="showTimer">
          <div *ngIf="item.customField31 && !isDealOver" fxLayout="row" fxLayoutAlign="start center" style="gap: 8px;">
            <span>{{item.customField25}}</span>
            <mat-chip color="primary" selected class="countdown">
              {{ days }}d&nbsp;&nbsp